import { HttpError } from '@/lib/https';

type SuppressionErrorEnvelope = {
  errors?: string[] | null;
};

export const parseSuppressionFieldErrors = (
  body: SuppressionErrorEnvelope | null | undefined
): Record<string, string[]> => {
  const fieldErrors: Record<string, string[]> = {};
  for (const entry of body?.errors ?? []) {
    const i = entry.indexOf(': ');
    if (i < 0) {
      (fieldErrors._generic ??= []).push(entry);
      continue;
    }
    const field = entry.slice(0, i);
    const message = entry.slice(i + 2);
    (fieldErrors[field] ??= []).push(message);
  }
  return fieldErrors;
};

export const getSuppressionHttpStatus = (error: unknown): number | undefined => {
  if (error instanceof HttpError) return error.status;
  if (typeof error === 'object' && error !== null && 'status' in error) {
    const status = (error as { status?: number }).status;
    return typeof status === 'number' ? status : undefined;
  }
  return undefined;
};

export const isSuppressionNotFoundError = (error: unknown): boolean =>
  getSuppressionHttpStatus(error) === 404;

export const getSuppressionConflictMessage = (error: unknown): string | undefined => {
  if (!(error instanceof HttpError) || error.status !== 409) return undefined;

  const body = error.error as { message?: string; errors?: string[] };

  const fromErrors = body?.errors?.find((entry) => typeof entry === 'string' && entry.trim());
  if (fromErrors?.trim()) {
    return fromErrors.trim();
  }

  if (typeof body?.message === 'string' && body.message.trim()) {
    return body.message.trim();
  }

  return undefined;
};
